import * as React from 'react';
export function typedMemo(Component, propsComparator) {
    return React.memo(Component, propsComparator);
}
//# sourceMappingURL=typedMemo.js.map